// Real product logo — sourced from docs/prototypes/img/app_icon.png
// and copied to admin/public/fincurry-logo.png. Any change to the
// brand should update that PNG (and this component's size table
// stays in sync with the sites that render it).
const SIZE_PX: Record<Size, { box: number; radius: number }> = {
  xs: { box: 28, radius: 8 },
  sm: { box: 32, radius: 8 },
  md: { box: 48, radius: 12 },
  lg: { box: 64, radius: 16 },
  xl: { box: 80, radius: 20 },
};

type Size = "xs" | "sm" | "md" | "lg" | "xl";

export interface FincurryLogoProps {
  size?: Size;
  className?: string;
}

export function FincurryLogo({
  size = "md",
  className = "",
}: FincurryLogoProps): React.JSX.Element {
  const { box, radius } = SIZE_PX[size];
  return (
    <div
      className={`relative overflow-hidden shadow-lg shadow-emerald-500/20 ${className}`}
      style={{ width: box, height: box, borderRadius: radius }}
    >
      <img
        src="/fincurry-icon.png"
        alt="Fincurry"
        width={box}
        height={box}
      />
    </div>
  );
}
